<template>
  <div class="invite-link-container">
    <label v-html="$t('referral.your.link')"></label>
    <div class="invite-link-inner">
      <a-input :placeholder="$t('referral.placeholder.link')" :value="referralLink"></a-input>
      <a-button @click="copy" type="primary">{{ $t('copy') }}</a-button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import { SHOW_NOTIFICATION } from '@/store/notification/actionTypes';

export default {
  computed: {
    ...mapGetters(['referralLink']),
  },
  methods: {
    ...mapActions({
      showNotification: SHOW_NOTIFICATION,
    }),
    copy() {
      window.navigator.clipboard.writeText(this.referralLink);
      this.showNotification({ message: this.$t('link.copied') });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/metrics.scss';

.invite-link-container {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: baseline;
}

.invite-link-inner {
  display: flex;
  align-items: center;
  margin-top: $tiny;
  flex: 1;
}

.ant-input {
  width: 100%;
}

.ant-btn {
  margin: 0;
  margin-left: $tiny;
}

label {
  flex: 1;
}
</style>
